import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/_services/auth.guard';
import { HomeComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { LoginComponent } from './components/pages/login/login.component';
import { SignupComponent } from './components/pages/signup/signup.component';
import { SpecialtiesComponent } from './components/pages/specialties/specialties.component';
import { AppointmentComponent } from './components/pages/appointment/appointment.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { SocialMediaComponent } from './components/pages/social-media/social-media.component';
import { StaffLoginComponent } from './components/pages/staff-login/staff-login.component';
import { CongratsComponent } from './components/pages/congrats/congrats.component';
import { PageQrComponent } from './components/pages/page-qr/page-qr.component';
import { CongratsCardsEditComponent } from './components/pages/congrats/congrats-cards-edit/congrats-cards-edit.component';
import { DownloadReportComponent } from './components/pages/download-report/downoad-report.component';
import { DoctorSlotsComponent } from './components/pages/doctor-slots/doctor-slots.component';
import { AddComplaintSuggestionComponent } from './components/pages/add-complaint-suggestion/add-complaint-suggestion.component';
import { BlogDetailsComponent } from './components/pages/blog/blog-details/blog-details.component';
import { AddEditSurveyComponent } from './components/pages/add-edit-survey/add-edit-survey.component';
import { MedicineLogComponent } from './components/pages/medicine-log/medicine-log.component';
import { OffersComponent } from './components/pages/offers/offers.component';
import { BookOfferComponent } from './components/pages/offers/book-offer/book-offer.component';
import { InvestmentComponent } from './components/pages/investment/investment.component';
import { CareerComponent } from './components/pages/career/career.component';
import { BoardComponent } from './components/pages/board/board.component';
import { HopitalComponent } from './components/pages/hopitals/hospital.component';
export const routes: Routes = [
  // {
  //   path: 'auth',
  //   loadChildren: () =>
  //     import('./modules/auth/auth.module').then((m) => m.AuthModule),
  // },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'portal',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  {path: '', component: HomeComponent},
    {path: 'about', component: AboutComponent},
    // {path: 'book-appointment', component: AppointmentComponent},
    // {path: 'specialties', component: SpecialtiesComponent},
    // {path: 'signup', component: SignupComponent},
    // {path: 'login', component: LoginComponent},
    {path: 'stafflogin', component: StaffLoginComponent},
    // {path: 'privacy-policy', component: PrivacyPolicyComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'boards/:page', component: BoardComponent},
    {path: 'boardofdirectors/:page', component: BoardComponent},
      {path: 'hospitals/:page', component: HopitalComponent},
    {path: 'medicalcenters/:page', component: HopitalComponent},
    {path: 'news', component: BlogComponent},
    {path: 'contact', component: ContactComponent},
    // {path: 'socialmedia', component: SocialMediaComponent},
    // {path: 'congrats-cards', component: CongratsComponent},
    // {path: 'card-edit', component: CongratsCardsEditComponent},
    // {path: 'mobileApplication', component: PageQrComponent},
    // {path: 'reports/:name/:visitId/:patientId', component: DownloadReportComponent},
    // {path: 'doctorslots/:specialtyId/:doctorId', component: DoctorSlotsComponent},
    // {path: 'complaints-suggestions', component: AddComplaintSuggestionComponent},
    // {path: 'news/details/:Id', component: BlogDetailsComponent},
    // {path: 'addsurvey/:visitId', component: AddEditSurveyComponent},
    // {path: 'medicinelog/:visitId', component: MedicineLogComponent},
    {path: 'investment', component: InvestmentComponent},
    // {path: 'careers', component: CareerComponent},

    // {path: 'offersandpackages/:AppId', component: OffersComponent},
    // {path: 'registerinfo/:SectionId/:AppId', component: BookOfferComponent},
    // {path: 'registerinfo/:SectionId/:OfferId/:AppId', component: BookOfferComponent},

  { path: '', redirectTo: 'auth', pathMatch: 'full' },

  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
